import { createPortal } from "react-dom";
import { Text, YStack } from "tamagui";

interface Props {
  open: boolean;
  message: string;
  onClose: () => void;
}

/**
 * 非營業時點「立即配送」的提示框（Kiosk 與 GasShop 共用）。
 * 只有一段文字＋一顆「確定」；按「確定」關閉。樣式依 2026-11-04 核准設計稿 B2/B3。
 * 掛到 document.body，避免被外層 sheet 的 transform / overflow 裁切。
 */
const RestNoticeDialog = ({ open, message, onClose }: Props) => {
  if (!open || typeof document === "undefined") return null;
  return createPortal(
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(15,26,53,.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
        zIndex: 100000,
      }}>
      <YStack
        role="dialog"
        aria-modal
        aria-label="提示"
        backgroundColor="#fff"
        borderRadius={18}
        pt={22}
        px={18}
        pb={16}
        width="100%"
        maxWidth={280}
        ai="center">
        <Text fontSize={16} fontWeight="700" color="#0f1a35" textAlign="center" lineHeight={24} mb={16}>
          {message}
        </Text>
        <button
          type="button"
          onClick={onClose}
          style={{
            width: "100%",
            border: 0,
            borderRadius: 12,
            background: "linear-gradient(to bottom,#2196f3,#1e88e5)",
            color: "#fff",
            fontSize: 16,
            fontWeight: 700,
            padding: "11px 0",
            cursor: "pointer",
          }}>
          確定
        </button>
      </YStack>
    </div>,
    document.body,
  );
};

export default RestNoticeDialog;
